import React from 'react';
import './ProductCards.css';
import { Row,Col } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';

import card1 from '../assets/Images/card1.png';
import card2 from '../assets/Images/card2.png';
import card4 from '../assets/Images/card4.png';
import card5 from '../assets/Images/card5.png';
import card6 from '../assets/Images/card6.png';
import card7 from '../assets/Images/ttt1.jpg';
const cardsData = [
  {
    id:1,
    title: 'Mops',
    description: 'Kentucky, Cotton,Mini & Flat Mops with high absorption quality and hygienic cleaning.',
    image: card1,
  },
  {
    id:2,
    title: 'Eagle Cleaning Cloths',
    description: 'Cleaning Clothes Perfect for cleaning hundreds of surfaces. They are safe and effectively clean and brighten glass, ceramic, chrome, plastic, marble, and aluminum. We deal in bulk quantity of Cleaning Clothes..',
    image: card2,
  },
 
  {
    id:3,
    title: 'Handles',
    description: 'All our handles are offered in color coded grips and matching color Mop Holders to complete the set.',
    image: card4,
  },
  {
    id:4,
    title: 'Frames and Holders',
    description: 'Frames are designed as per industrial standard extra durability and 360 degree swivel motion.Made from polypropylene body and rugged',
    image: card5,
  },
  {
    id:5,
    title: 'Miscellaneous',
    description: 'A complete cleaning kit with all solutions for daily cleaning needs.The value kit contains a durable metal handle, a flat mop holder plastic along with two flat mops for dry & wet cleaning.',
    image: card6,
  },
{
    id:6,
    title: 'Trolleys',
    description: 'A complete cleaning kit with all solutions for daily cleaning needs.it is very helpful ',
    image: card7,
  },


];

function ProductCards() {
  const navigate=useNavigate();
  return (
    <div className="product-section">
      <h2 className="section-title">Explore Eagle Products</h2>
      <p className="section-desc">
        Kentucky Mop Microfiber Cloth gives shiny and cleaner look to any surface. Holds more dust, cleans floors more quickly and have longer life than cotton mops. Hygienic Chemical Free Green Cleaning Mop made up with prime microfiber yarn.
      </p>

      <Row className="g-4">
        {cardsData.map((card) => (
          <Col key={card.id} lg={4} md={4} sm={12}>
            <div className="product-card">
              <img src={card.image} alt={card.title} className="card-img" />
              <div className="card-overlay">
                <h3>{card.title}</h3>
                <p>{card.description}</p>
                <button onClick={() => navigate(`/card/${card.id}`)}>Read More</button>
              </div>
            </div>
          </Col>
        ))}
      </Row>
    </div>
   
  );
}


export default ProductCards;